import cx from 'classnames'
import { type ReactNode, useState } from 'react'

import { Button } from '../../actions/button/Button'
import { Icon } from '../icon/Icon'
import { Typography } from '../typography/Typography'
import { Card } from './Card'
import { CardBody } from './CardBody'

type Props = {
  title: string
  children: ReactNode
  className?: string
  isInitialOpen?: boolean
}

export const CollapsibleCard = ({
  title,
  children,
  className,
  isInitialOpen = true,
}: Props) => {
  const [isOpen, setIsOpen] = useState(isInitialOpen)
  const [shouldAnimate, setShouldAnimate] = useState(false)
  const handleToggle = () => {
    setShouldAnimate(true)
    setIsOpen((prev) => !prev)
  }

  return (
    <Card className={className}>
      <Button
        variant="discreet"
        onClick={handleToggle}
        aria-expanded={isOpen}
        className="p-1! -my-0.5 justify-start!"
      >
        <Icon
          name="ChevronRight"
          className={cx('transition-transform', isOpen && 'rotate-90')}
        />
        <Typography weight="semibold" intensity="primary">
          {title}
        </Typography>
      </Button>
      {isOpen && (
        <CardBody
          innerClassName={cx(
            { '*:animate-fade-in-down': shouldAnimate }, // We deliberately animate children to avoid flash of card background when opening
          )}
          gap="spacious"
        >
          {children}
        </CardBody>
      )}
    </Card>
  )
}
